<template>
  <div>
    <MasterLayout>
      <div class="dashboard_first_row">
        <div class="buttons_section">
          <div>
            <vue-ctk-date-time-picker
              v-model="dateRange"
              :max-date="maxDate"
              :range="true"
              :autoClose="true"
              :custom-shortcuts="customShortcuts"
              color="#4b2c72"
              format="DDMMYYYY"
              formatted="DD/MM/YYYY"
              :label="$t('text.calendar.dateRange')"
            />
          </div>
          <div class="pos_select_branch">
            <select class="btn details_btn px-3 mr-3 mt-2" v-model="branchId">
              <option disabled value="selectABranch">
                {{ $t("text.branch.selectBranch") }}
              </option>
              <option value="showAll">{{ $t("text.branch.showAll") }}</option>
              <option
                v-for="(branch, index) in branches"
                :key="index"
                v-bind:value="branch.id"
              >
                {{ branch.name }}
              </option>
            </select>
          </div>
          <div class="pos_select_branch">
            <select class="btn details_btn px-3 mr-3 mt-2" v-model="status">
              <option disabled value="selectAStatus">
                {{ $t("text.branch.selectStatus") }}
              </option>
              <option value="">{{ $t("text.branch.showAll") }}</option>
              <option value="00">{{ $t("text.branch.approved") }}</option>
              <option value="0x0x0">{{ $t("text.branch.declined") }}</option>
            </select>
          </div>
        </div>
        <div class="row mt-3 pos_trans_card_holder">
          <div class="col-lg-3 col-md-3 remove_padding-right pos_trans_card">
            <div class="card_container_1 pos-card mt-3">
              <p class="dashboard__card__header text-uppercase text-center">
                {{ $t("text.branch.totalTransactions") }}
              </p>
              <div class="icon_wrapper inner_border_radius mx-auto">
                <img src="@/assets/img/credit-card (4).svg" width="40px" />
              </div>
              <div class="mt-3 text-center">
                <h3 class="font-weight-bold">
                  {{ group ? group.currencyCode : "" }}
                  {{ totalTransactionsAmount }}
                </h3>
                <small class="dashboard__card__header_bottom font-weight-bold">
                  {{ totalTransactions }}
                </small>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 remove_padding-right pos_trans_card">
            <div class="card_container_1 pos-card mt-3">
              <p class="dashboard__card__header text-uppercase text-center">
                {{ $t("text.branch.successfulTransactions") }}
              </p>
              <div class="icon_wrapper inner_border_radius mx-auto">
                <img src="@/assets/img/credit-card (2).svg" width="40px" />
              </div>
              <div class="mt-3 text-center">
                <h3 class="font-weight-bold">
                  {{ group ? group.currencyCode : "" }}
                  {{ totalSuccessfulTransactionsAmount }}
                </h3>
                <small
                  class="dashboard__card__header_bottom font-weight-bold"
                  >{{ totalSuccessfulTransactions }}</small
                >
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 remove_padding-right pos_trans_card">
            <div class="card_container_1 pos-card mt-3">
              <p class="dashboard__card__header text-uppercase text-center">
                {{ $t("text.branch.failedTransactions") }}
              </p>
              <div class="icon_wrapper inner_border_radius mx-auto">
                <img src="@/assets/img/credit-card (3).svg" width="40px" />
              </div>
              <div class="mt-3 text-center">
                <h3 class="font-weight-bold">
                  {{ group ? group.currencyCode : "" }}
                  {{ totalFailedTransactionsAmount }}
                </h3>
                <small
                  class="dashboard__card__header_bottom font-weight-bold"
                  >{{ totalFailedTransactions }}</small
                >
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-3 remove_padding-right pos_trans_card">
            <div class="card_container_1 pos-card mt-3">
              <p class="dashboard__card__header text-uppercase text-center">
                {{ $t("text.cBank.transaction.totalBalance") }}
              </p>
              <div class="icon_wrapper inner_border_radius mx-auto">
                <img src="@/assets/img/credit-card (6).svg" width="40px" />
              </div>
              <div class="mt-3 text-center">
                <h3 class="font-weight-bold">
                  {{ group ? group.currencyCode : "" }} {{ groupBalance }}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section>
        <div class="pos_table">
          <div class="row top_section_row" v-show="!showLoader">
            <div class="col-md-8">
              <span class="sec_text_color">
                {{ $t("text.branch.posTrans") }} {{ startDate }}
                {{ $t("text.branch.and") }} {{ endDate }}
              </span>
              <span> </span>
            </div>
            <div class="col-md-4 text-right"></div>
          </div>
          <ejs-grid
            v-show="!showLoader"
            ref="dataGrid"
            :created="refreshGrid"
            :allowPaging="true"
            :allowSorting="true"
            :toolbar="toolbar"
            :pageSettings="pageSettings"
            :searchSettings="search"
            :allowExcelExport="true"
            :allowPdfExport="true"
            :toolbarClick="toolbarClick"
            :rowDataBound="rowDataBound"
            :allowTextWrap="true"
            :excelQueryCellInfo="excelQueryCellInfo"
            :locale="usedLang"
          >
            <e-columns>
              <e-column
                width="80"
                field="index"
                :allowSorting="false"
                headerText="#"
              ></e-column>
              <e-column
                field="paymentDate"
                :format="formatOptions"
                type="date"
                width="200"
                :headerText="$t('text.branch.transDate')"
              ></e-column>
              <e-column
                :visible="!branchSelected"
                field="branchName"
                width="180"
                :headerText="$t('text.branch.station')"
              ></e-column>
              <e-column
                field="pumpName"
                width="100"
                :headerText="$t('text.branch.pump')"
              ></e-column>
              <e-column
                field="amount"
                width="150"
                format="N2"
                :headerText="`Amount(${group ? group.currency : ''})`"
              ></e-column>
              <e-column
                field="stan"
                width="220"
                :headerText="$t('text.branch.stan')"
              ></e-column>
              <e-column
                field="retrievalReferenceNumber"
                width="220"
                :headerText="$t('text.branch.rrn')"
              ></e-column>
              <e-column
                field="maskedPan"
                width="220"
                :headerText="$t('text.branch.maskedPan')"
              ></e-column>
              <e-column
                field="statusDescription"
                width="200"
                :headerText="$t('text.branch.status')"
              ></e-column>
              <e-column
                width="180"
                :template="actionTemplate"
                :headerText="$t('text.branch.action')"
              ></e-column>
            </e-columns>
          </ejs-grid>
        </div>

        <TableLoader :showLoader="showLoader" />
      </section>
    </MasterLayout>
    <POSModal :modalData="modalData"></POSModal>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/groupManagement/MasterLayout.vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import POSModal from "@/components/modals/POS/index";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "POS Transactions:: Epump Portal",
  name: "POS-Transactions",
  components: {
    MasterLayout,
    TableLoader,
    POSModal,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      groupBalance:0,
      usedLang: this.$store.getters.getLanguage,
      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      branchSelected: false,
      totalCharges: 0,
      totalChargesCount: 0,
      branches: null,
      branchId: "selectABranch",
      status: "selectAStatus",
      group: null,
      terminalId: "",
      totalTransactions: 0,
      totalTransactionsAmount: 0,
      totalSuccessfulTransactions: 0,
      totalSuccessfulTransactionsAmount: 0,
      totalFailedTransactions: 0,
      totalFailedTransactionsAmount: 0,
      modalData: null,
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(7, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      showLoader: true,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },

      actionTemplate: function () {
        return {
          template: Vue.component("actionButtonsTemplate", {
            template: `<div class="btn dealers_btn mr-3" @click="showDetails(data)">
                        Details
                    </div>`,
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              showDetails(data) {
                this.$eventHub.$emit("showDetails", data);
              },
            },
          }),
        };
      },
    };
  },
  created() {
    this.$eventHub.$on("group", (group) => {
      this.group = group;
    });
    if (this.$route.query.groupId) {
      this.getBranches();
      this.getTransactions();
      this.getGroupBalance()
    }
    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;
    this.$eventHub.$on("showDetails", (data) => {
      this.modalData = data;
      this.$modal.show("POSModal");
    });
    this.$eventHub.$on("PrintPos", () => {
      this.printWithCSS();
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("showDetails");
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  watch: {
    group(group) {
      if (group !== null) {
        this.getBranches();
        this.getTransactions();
        this.getGroupBalance()
      }
    },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.getTransactions();
      }
    },
    branchId: function (newId, oldId) {
      if (newId !== null && newId !== "selectABranch") {
        this.getTransactions();
      }
    },
    status: function (newStatus, oldStatus) {
      if (newStatus !== null && newStatus !== "selectAStatus") {
        this.getTransactions();
      }
    },
  },
  methods: {
    getGroupBalance() {
  
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Pos/GroupBalance/${
            this.$route.query.groupId
              ? this.$route.query.groupId
              : this.group.id
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          this.groupBalance = this.convertThousand(response.data.balance);
        })
        .catch((error) => {});
    },
    printWithCSS() {
      var elementHTML = $("#printContent").html();
      var myWindow = window.open("", "", "width=1000,height=700");
      myWindow.document.write(elementHTML);
      var style = myWindow.document.createElement("style");
      style.innerHTML = `
        @page {
          size: auto;  /* auto is the initial value */
          margin: 0mm; /* this affects the margin in the printer settings */
        }
        html {
          background-color: #FFFFFF;
          margin: 0px; /* this affects the margin on the HTML before sending to printer */
        }
        body {
          margin: 10mm 15mm 10mm 15mm; /* margin you want for the content */
          margin: 0mm;
          max-width:465px; 
          padding:15px 0px;
        }
        
        `;
      myWindow.document.head.appendChild(style);
      myWindow.document.close();
      myWindow.focus();
      myWindow.print();
      myWindow.close();
    },
    excelQueryCellInfo(args) {
      if (args.column.field == "paymentDate") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY");
      }
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "POS Transactions.pdf",
          };
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    rowDataBound: function (args) {
      if (args.data["statusCode"] === "00") {
        args.row.cells[8].style.color = "green";
      } else {
        args.row.cells[8].style.color = "red";
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    getBranches() {
      // const company = JSON.parse(localStorage.getItem("companyDetails"));
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/GroupBranches/${
            this.$route.query.groupId
              ? this.$route.query.groupId
              : this.group.id
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.sort((a, b) => {
            return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
          });
          this.branches = response.data;
        })
        .catch((error) => {});
    },
    getTransactions() {
      this.showLoader = true;
      let grid = this.$refs.dataGrid;
      const status = this.status == "selectAStatus" ? "" : this.status;
      let url;
      if (this.branchId == "selectABranch" || this.branchId == "showAll") {
        url = `${configObject.apiBaseUrl}/Pos/GroupTransactions/${
          this.$route.query.groupId ? this.$route.query.groupId : this.group.id
        }?startDate=${this.startDate}&endDate=${this.endDate}&status=${status}`;
      } else {
        url = `${configObject.apiBaseUrl}/Pos/Transactions/${this.branchId}?startDate=${this.startDate}&endDate=${this.endDate}&status=${status}&terminalId=${this.terminalId}`;
      }
      this.axios
        .get(url, configObject.authConfig())
        .then((response) => {
          let index = 0;
          let totalTransactionsAmount = 0;
          let totalSuccessfulTransactions = 0;
          let totalSuccessfulTransactionsAmount = 0;
          let totalFailedTransactions = 0;
          let totalFailedTransactionsAmount = 0;
          let totalCharges = 0;
          let totalChargesCount = 0;

          response.data.sort((a, b) =>
            a.paymentDate < b.paymentDate
              ? 1
              : a.paymentDate > b.paymentDate
              ? -1
              : 0
          );

          if (this.branchId == "selectABranch" || this.branchId == "showAll") {
            this.branchSelected = false;
            response.data.sort((a, b) => {
              if (a.date !== b.date) {
                return a.branchName.toLowerCase() < b.branchName.toLowerCase()
                  ? -1
                  : a.branchName.toLowerCase() > b.branchName.toLowerCase()
                  ? 1
                  : 0;
              }
            });
          } else {
            this.branchSelected = true;
          }

          response.data.forEach((cur) => {
            cur.index = ++index;
            totalTransactionsAmount += cur.amount;
            totalCharges += cur.charge;
            totalChargesCount++;
            if (cur.statusCode == "00") {
              totalSuccessfulTransactions += 1;
              totalSuccessfulTransactionsAmount += cur.amount;
            } else {
              totalFailedTransactions += 1;
              totalFailedTransactionsAmount += cur.amount;
            }

            if (!cur.pumpName) {
              JSON.parse(cur.additionalInformation).forEach((current) => {
                if (current.Name == "PumpName") {
                  cur.pumpName = current.Value;
                }
              });
            } else {
              cur.pumpName = cur.pumpName;
            }
          });
          this.totalTransactionsAmount = this.convertThousand(
            totalTransactionsAmount
          );
          this.totalSuccessfulTransactionsAmount = this.convertThousand(
            totalSuccessfulTransactionsAmount
          );
          this.totalFailedTransactionsAmount = this.convertThousand(
            totalFailedTransactionsAmount
          );
          this.totalCharges = this.convertThousand(totalCharges);

          this.totalTransactions = response.data.length;
          this.totalSuccessfulTransactions = totalSuccessfulTransactions;
          this.totalFailedTransactions = totalFailedTransactions;
          this.totalChargesCount = totalChargesCount;

          this.showLoader = false;
          grid.ej2Instances.setProperties({ dataSource: response.data });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
<style>
@media screen and (max-width: 602px) {
  .POSModal .v--modal-box.v--modal {
    margin: 0 auto;
    top: 112px !important;
    width: 90% !important;
    height: 500px !important;
    left: 0 !important;
    overflow: auto;
  }
  .POSModal .v--modal-box.v--modal {
    margin: 0 auto;
    /* top: 88px !important; */
    width: 90% !important;
    height: 379px !important;
    left: 0 !important;
    overflow: auto;
  }
  button.add_quick_fuel_btn {
    margin-bottom: 62px;
  }
}
</style>
